module.exports = __webpack_public_path__ + "h5/img/bb2.9da2cbc1.png";